<div class="ui-g ui-fluid table-column-header-span">
  <div class="ui-g-10 table-column-header-text">
    <label
      class="table-column-header-label"
      [translate]="column.header"
    ></label>
  </div>
  <div class="ui-g-3 table-column-header-sort">
    @if (column.sortable) {
      <p-sortIcon [field]="column.field" />
    }
  </div>
</div>
